import "../../_namespaces.js";
import "../../_generated_templates.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.AssessmentProgress = class AssessmentProgress extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }
};
AssessmentViewer.Views.AssessmentProgress.prototype.tagName = "div";
AssessmentViewer.Views.AssessmentProgress.prototype.className = "assessment-view assessment-view--progress";
AssessmentViewer.Views.AssessmentProgress.prototype.template = _.template(
  AssessmentViewer.Templates.Assessment.progress,
);
